import React from "react";
import { AlertTriangle } from "lucide-react";

interface DeleteTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  template: any;
  onConfirmDelete: () => void;
  isLoading: boolean;
}

const DeleteTemplateModal: React.FC<DeleteTemplateModalProps> = ({
  isOpen,
  onClose,
  template,
  onConfirmDelete,
  isLoading,
}) => {
  if (!isOpen || !template) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-center mb-4">
          <AlertTriangle className="h-10 w-10 text-red-500" />
        </div>

        <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
          Delete Template
        </h3>

        <p className="text-sm text-gray-500 text-center mb-6">
          Are you sure you want to delete the template "
          <span className="font-semibold">{template.name}</span>"? This action
          cannot be undone.
        </p>

        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirmDelete}
            disabled={isLoading}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Deleting..." : "Delete Template"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTemplateModal;
